const langAuthPasswordReset = {
	title_reset_password: {
		tag: 'auth.reset_password.title_reset_password',
		fr: 'Réinitialisez votre mot de passe',
		en: 'Reinit your password',
	},
	label_password: {
		tag: 'auth.reset_password.label_password',
		fr: 'Créez un nouveau mot de passe',
		en: 'Create a new password',
	},
	label_password_helpertext: {
		tag: 'auth.reset_password.label_password_helpertext',
		fr: 'Le mot de passe doit contenir au moins 8 caractères, 1 chiffre, 1 lettre majuscule et 1 lettre minuscule',
		en: 'The password must contain at least 8 characters, 1 number, 1 upper case letter and 1 lower case letter',
	},
	label_password_confirmation: {
		tag: 'auth.reset_password.label_password_confirmation',
		fr: 'Confirmez votre nouveau mot de passe',
		en: 'Confirm your new password',
	},
	btn_reset_password: {
		tag: 'auth.reset_password.btn_reset_password',
		fr: 'Réinitialiser mon mot de passe',
		en: 'Reinit my password',
	},
	btn_login: {
		tag: 'auth.reset_password.btn_login',
		fr: 'Se connecter',
		en: 'Sign-in',
	},
	field_error_password_required: {
		tag: 'auth.reset_password.field_error_password_required',
		fr: 'Le mot de passe est requis',
		en: 'Password is required',
	},
	field_error_password_too_short: {
		tag: 'auth.reset_password.field_error_password_too_short',
		fr: 'Le mot de passe est trop court',
		en: 'Password is too short',
	},
	field_error_password_must_contain_one_lowercase: {
		tag: 'auth.reset_password.field_error_password_must_contain_one_lowercase',
		fr: 'Le mot de passe doit contenir au moins une minuscule',
		en: 'Password must contain at least one lowercase',
	},
	field_error_password_must_contain_one_uppercase: {
		tag: 'auth.reset_password.field_error_password_must_contain_one_uppercase',
		fr: 'Le mot de passe doit contenir au moins une majuscule',
		en: 'Password must contain at least one uppercase',
	},
	field_error_password_must_contain_one_number: {
		tag: 'auth.reset_password.field_error_password_must_contain_one_number',
		fr: 'Le mot de passe doit contenir au moins un chiffre',
		en: 'Password must contain at least one number',
	},
	field_error_passwords_do_not_match: {
		tag: 'auth.reset_password.field_error_passwords_do_not_match',
		fr: 'Les mots de passe ne correspondent pas',
		en: 'Passwords do not match',
	},
	field_error_password_confirm_required: {
		tag: 'auth.reset_password.field_error_password_confirm_required',
		fr: 'La confirmation du mot de passe est requise',
		en: 'Password confirm is required',
	},
	text_success: {
		tag: 'auth.reset_password.text_success',
		fr: 'Félicitations, votre nouveau mot de passe est bien enregistré.',
		en: 'Congratulations, your new password is registered.',
	},
	text_link_invalid: {
		tag: 'auth.reset_password.text_link_invalid',
		fr: "Le lien sur lequel vous avez cliqué n'est plus valide.",
		en: 'The link you clicked is no longer valid.',
	},
};

export default langAuthPasswordReset;
